const testimonials = [
    {
      text: "Amazing service that transformed our business operations and helped us achieve 10x growth in a short time.",
      name: "Amit Sharma",
      role: "Startup Founder",
      img: "https://i.pravatar.cc/100?img=1",
    },
    {
      text: "Highly professional team that delivered outstanding results with clear communication and seamless collaboration throughout..",
      name: "Neha Verma",
      role: "Marketing Manager",
      img: "https://i.pravatar.cc/100?img=2",
    },
    {
      text: "Impressive results that improved our campaign performance and drove higher conversions and business growth.",
      name: "Rahul Singh",
      role: "E-commerce Owner",
      img: "https://i.pravatar.cc/100?img=3",
    },
    {
      text: "AI automation improved our workflow and productivity while saving hours of repetitive work daily.",
      name: "Karan Gupta",
      role: "Tech Lead",
      img: "https://i.pravatar.cc/100?img=4",
    },
  ];

  export default testimonials;